import React, { useEffect, useState } from "react";
import { Parents } from "../utils/CartegoryParent";
import {
  AdminCreateBrand,
  AdminViewSingleCategory,
  addCategory,
  getCategory,
  updateCategory,
  updateSubCategory,
  deleteSubCategory,
  checkSubcategoryProducts,
} from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const UpdateCategoryForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const currentUser = useRecoilValue(userState);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [load, setLoad] = useState(false);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [showUpdateSub, setShowUpdateSub] = useState(false);
  const [allCartegory, setAllCartegory] = useState([]);
  const [updateDataId, setUpdateDataId] = useState(0);
  const [categoryData, setCategoryData] = useState({
    category: {},
    subcategories: [],
    brands: [],
  });
  const [data, setData] = useState({
    categoryName: "",
    description: "",
  });
  const [subCategoryData, setSubCategoryData] = useState({
    subcategory: "",
    brands: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "",
    images: null,
  });

  const [deleteConfirmed, confirmDelete] = useState(null);
  const [subcategoryToDelete, setSubcategoryToDelete] = useState(null);
  const [showDestinationModal, setShowDestinationModal] = useState(false);
  const [showSimpleConfirm, setShowSimpleConfirm] = useState(false);
  const [destinationSubCategoryId, setDestinationSubCategoryId] = useState('');
  const [productCheck, setProductCheck] = useState(null);

  const handleConfirm = async () => {
    let data = {
      categoryId: params.categoryId,
      subCategoryId: deleteConfirmed || subcategoryToDelete?.ID,
      destinationSubCategoryId: destinationSubCategoryId || undefined,
    };
    
    try {
      console.log("Deleting subcategory:", data);
      const deleteResponse = await deleteSubCategory(data);
      console.log("Delete response:", deleteResponse);
      
      // Close modals
      confirmDelete(null);
      setShowSimpleConfirm(false);
      setShowDestinationModal(false);
      setSubcategoryToDelete(null);
      
      // Show success message
      if (deleteResponse?.message || deleteResponse) {
        const movedProducts = deleteResponse.movedProducts || 0;
        const deletedBrands = deleteResponse.deletedBrands || 0;
        const movedBrands = deleteResponse.movedBrands || 0;
        const destSub = deleteResponse.destinationSubcategory || "None";
        
        let message = "Subcategory deleted successfully.";
        if (movedProducts > 0) {
          message += ` ${movedProducts} product(s) updated.`;
        }
        if (movedBrands > 0) {
          message += ` ${movedBrands} brand(s) moved to "${destSub}".`;
        }
        if (deletedBrands > 0) {
          message += ` ${deletedBrands} brand(s) removed.`;
        }
        
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: message,
          timer: 3000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      }
    } catch (error) {
      console.error(error);
      confirmDelete(null);
      setShowSimpleConfirm(false);
      setShowDestinationModal(false);
      
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to delete subcategory",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  // Smart delete handler for subcategories
  const handleDeleteClick = async (subcategory) => {
    setSubcategoryToDelete(subcategory);

    try {
      const checkResponse = await checkSubcategoryProducts(params.categoryId, subcategory.ID);
      console.log("Product check:", checkResponse.data);
      setProductCheck(checkResponse.data);

      // Flow 1: No products/brands → simple confirmation
      if (!checkResponse.data.hasProducts && !checkResponse.data.hasBrands) {
        setShowSimpleConfirm(true);
      }
      // Flow 2: Has products/brands → show destination selector
      else {
        setShowDestinationModal(true);
      }
    } catch (error) {
      console.error("Error checking subcategory:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to check subcategory. Please try again.",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  // Destination Modal for subcategories
  const DestinationModal = ({ show, productCheck, onConfirm, onCancel }) => {
    const [selection, setSelection] = useState("clear");
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");

    if (!show || !productCheck) return null;

    return (
      <>
        <div className="modal-backdrop fade show"></div>
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h5 className="modal-title" style={{ color: "#bb2d5e" }}>
                  Subcategory Has Data
                </h5>
                <button className="btn-close" onClick={onCancel} />
              </div>

              <div className="modal-body">
                <p>
                  This subcategory has{" "}
                  <strong>{productCheck.productCount} product(s)</strong>
                  {productCheck.brandCount > 0 && ` and `}
                  {productCheck.brandCount > 0 && (
                    <strong>{productCheck.brandCount} brand(s)</strong>
                  )}
                  .
                </p>
                <p className="mt-2">What should happen to them?</p>

                <div className="form-check mb-2">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="clearSubcategory"
                    checked={selection === "clear"}
                    onChange={() => setSelection("clear")}
                  />
                  <label className="form-check-label" htmlFor="clearSubcategory">
                    Clear subcategory (products keep category, brands deleted)
                  </label>
                </div>

                <div className="form-check mb-3">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="moveToOther"
                    checked={selection === "move"}
                    onChange={() => setSelection("move")}
                  />
                  <label className="form-check-label" htmlFor="moveToOther">
                    Move to another subcategory
                  </label>
                </div>

                {selection === "move" && (
                  <select
                    className="form-select"
                    value={selectedSubCategoryId}
                    onChange={(e) => setSelectedSubCategoryId(e.target.value)}
                  >
                    <option value="">-- Select Subcategory --</option>
                    {categoryData.subcategories
                      .filter(sub => sub.ID !== subcategoryToDelete?.ID)
                      .map(sub => (
                        <option key={sub.ID} value={sub.ID}>
                          {sub.subCategoryName}
                        </option>
                      ))
                    }
                  </select>
                )}
              </div>

              <div className="modal-footer" style={{ borderTop: "none" }}>
                <button className="btn btn-secondary" onClick={onCancel}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setDestinationSubCategoryId(
                      selection === "move" ? selectedSubCategoryId : ""
                    );
                    onConfirm();
                  }}
                  disabled={selection === "move" && !selectedSubCategoryId}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  // Confirm delete component...
  const ConfirmModal = ({
    show,
    title = "Confirm Delete",
    message = "Are you sure you want to delete this category?",
    onConfirm,
    onCancel,
  }) => {
    if (!show) return null;

    return (
      <>
        {/* Backdrop */}
        <div className="modal-backdrop fade show"></div>

        {/* Modal */}
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h5 className="modal-title" style={{ color: "#bb2d5e" }}>
                  {title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onCancel}
                />
              </div>

              <div className="modal-body text-center">
                <p className="mb-0">{message}</p>
              </div>

              <div className="modal-footer" style={{ borderTop: "none" }}>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onCancel}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn text-white"
                  style={{ backgroundColor: "#bb2d5e" }}
                  onClick={onConfirm}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const OnHandleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const avatarFile = files[0];
      const url = URL.createObjectURL(avatarFile);
      setPreviewImageUrl(url);

      setFormData((prev) => ({
        ...prev,
        [name]: avatarFile,
      }));
    } else {
      setFormData((prevProfile) => ({
        ...prevProfile,
        [name]: value,
      }));
    }
  };

  const ViewAllCartegory = async () => {
    try {
      const response = await AdminViewSingleCategory(
        currentUser?.data?.info?.id,
      );
      setAllCartegory(response.data);
    } catch (err) {
      return err;
    }
  };
  useEffect(() => {
    getSingleCategory();
  }, []);
  const getSingleCategory = async () => {
    try {
      const res = await getCategory(params.categoryId);

      setCategoryData({
        category: res.category,
        subcategories: res.subCategories,
        brands: res.brands,
      });
      setData({
        categoryName: res.category.categoryName,
        description: res.category.description,
      });
    } catch (err) {
      return err;
    }
  };

  const onCategoryChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onSubCategoryChange = (e) => {
    const { name, value } = e.target;

    setSubCategoryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onUpdateCategory = async (e) => {
    e.preventDefault();

    const res = await updateCategory({
      categoryId: params.categoryId,
      categoryName: data.categoryName,
      description: data.description,
    });
    if (res) {
      Swal.fire({
        title: "Category Updated Successfully",
        icon: "success",
      }).then(() => {
        //window.location.reload();
        // navigate("/categories");
      });
    }
  };
  const onUpdateSubCategory = async (e) => {
    e.preventDefault();

    const res = await updateSubCategory({
      categoryId: params.categoryId,
      subCategoryId: updateDataId,
      subcategory: subCategoryData.subcategory,
      brands: subCategoryData.brands,
    });
    if (res) {
      Swal.fire({
        title: "SubCategory/Brands Updated Successfully",
        icon: "success",
      }).then(() => {
        //window.location.reload();
        // navigate("/categories");
      });
    }
  };
  const onAction = (type, id) => {
    let subcategories = categoryData.subcategories.filter(
      (item, i) => item.ID === id,
    );
    let brands = categoryData.brands.filter(
      (item, i) => item.subCategoryId === subcategories[0].ID,
    );
    setSubCategoryData({
      subcategory: subcategories[0].subCategoryName,
      brands: brands[0].brandName,
    });

    switch (type) {
      case "view":
        setShowUpdateSub(false);
        break;
      case "update":
        setUpdateDataId(id);
        setShowUpdateSub(true);
        break;
      // case "delete":

      // 	break;
    }
    setShowSubCategory(true);
  };
  return (
    <div>
      <section class="content-main">
        <div class="row">
          <div class="col-12">
            <div class="content-header">
              <h2 class="content-title">Update Category</h2>
              <div>
                <button
                  onClick={onUpdateCategory}
                  class="btn btn-md rounded font-sm hover-up"
                >
                  Update Category
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div class="col-md-6">
            <div class="card mb-4">
              {/* <div class='card-header'>
								<h4>Basic</h4>
							</div> */}
              <div class="card-body">
                <form>
                  <div class="mb-3">
                    <label for="product_name" class="form-label">
                      Category name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      required
                      name="categoryName"
                      onChange={onCategoryChange}
                      type="text"
                      value={data && data.categoryName}
                      placeholder="Type here"
                      class="form-control"
                      id="category_name"
                    />
                  </div>
                  {/* <div className="row">
										<div className="col-md-6 mb-3">
											<label class='form-label'>Sub Category</label>
											<select
												id="subcategory"
												name='subcategory'
												// onChange={OnHandleChange}
												class='form-select'>
												<option value="">--Select sub category--</option>

												{allCartegory?.map((props) => (
													<option value={props.slug.replace("/", "")}>
														{props.slug.replace("/", "")}
													</option>
												))}
											</select>
										</div>
										<div className="col-md-6 mb-3">
											<label class='form-label'>Brands</label>
											<select
												id="brand"
												name='brands'
												// onChange={OnHandleChange}
												class='form-select'>
												<option value="">--Select brand--</option>

												{allCartegory?.map((props) => (
													<option value={props.slug.replace("/", "")}>
														{props.slug.replace("/", "")}
													</option>
												))}
											</select>
										</div>
									</div> */}
                  <div className="row">
                    <div class="col-md-12 mb-4">
                      <label class="form-label">
                        Full description<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        required
                        name="description"
                        onChange={onCategoryChange}
                        value={data && data.description}
                        placeholder="Type here"
                        class="form-control"
                        rows="4"
                      ></textarea>
                    </div>
                  </div>
                  {/* <div className="row mb-3" >
										<div
											role="button"
											className="col-md-12 d-flex justify-content-end"
											style={{ color: '#bb2d5e', fontWeight: 400 }}
											onClick={() => setShowSubCategory(!showSubCategory)}>
											<i class="material-icons md-post_add"></i><span>Add Subcategory</span>
										</div>
									</div> */}
                </form>
              </div>
            </div>
            {/* <!-- card end// --> */}
          </div>
          {/* </div> */}
        </div>
        <div className="row">
          <div className="col-md-6 card mb-3">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">SubCategory Id</th>
                      <th scope="col">SubCategory Name</th>
                      <th scope="col" class="text-end">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoryData ? (
                      categoryData.subcategories.map((category, i) => (
                        <tr key={"category" + i}>
                          <td>{i + 1}</td>
                          <td>{category.ID}</td>
                          <td>{category.subCategoryName}</td>
                          <td class="text-end">
                            <div class="mb-5">
                              <div
                                role="button"
                                class="dropdown-item"
                                onClick={(e) => onAction("view", category.ID)}
                              >
                                View
                              </div>
                              <div
                                role="button"
                                class="dropdown-item"
                                onClick={(e) => onAction("update", category.ID)}
                              >
                                Update
                              </div>

                              <div
                                className="dropdown-item"
                                onClick={() => handleDeleteClick(category)}
                              >
                                Delete
                              </div>
                              {/* <div
																role="button"
																class="dropdown-item text-danger"
																onClick={(e) => onAction("delete", category.ID)}
															>
																Delete
															</div> */}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <div>No order Found</div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {showSubCategory ? (
            // <div className="row">
            <div class="col-md-6">
              <div class="card mb-3">
                <div class="card-header">
                  <h4>Sub Category ({subCategoryData.subcategory})</h4>
                </div>
                <div class="card-body">
                  <form>
                    <div class="mb-3">
                      <label for="product_name" class="form-label">
                        Sub-Category name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        required
                        name="subcategory"
                        onChange={onSubCategoryChange}
                        type="text"
                        value={subCategoryData.subcategory}
                        placeholder="Type here"
                        class="form-control"
                        id="subcategory_name"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="product_name" class="form-label">
                        Brands (comma separated list){" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        required
                        name="brands"
                        onChange={onSubCategoryChange}
                        value={subCategoryData.brands}
                        placeholder="Type here"
                        class="form-control"
                        rows="4"
                      />
                    </div>

                    {/* <div class='mb-4'>
										<label class='form-label'>Full description<span style = {{color : 'red'}}>*</span></label>
										<textarea
											required
											name='description'
											onChange={OnHandleChange}
											placeholder='Type here'
											class='form-control'
											rows='4'></textarea>
									</div> */}
                    <div className="d-flex justify-content-end">
                      {/* <button class='btn btn-light rounded font-sm mr-5 text-body hover-up'>
									Save to draft
								</button> */}

                      {showUpdateSub ? (
                        <button
                          onClick={onUpdateSubCategory}
                          class="btn btn-md rounded font-sm hover-up"
                        >
                          Update SubCategory/Brands
                        </button>
                      ) : (
                        <button
                          onClick={() => setShowSubCategory(false)}
                          class="btn btn-md rounded font-sm hover-up"
                        >
                          Close
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              {/* <!-- card end// --> */}
            </div>
          ) : (
            ""
          )}
        </div>
       <ConfirmModal
          show={deleteConfirmed != null}
          onConfirm={handleConfirm}
          onCancel={() => confirmDelete(null)}
        />
        
        {/* Destination Modal */}
        <DestinationModal
          show={showDestinationModal}
          productCheck={productCheck}
          onConfirm={handleConfirm}
          onCancel={() => {
            setShowDestinationModal(false);
            setSubcategoryToDelete(null);
          }}
        />
        
        {/* Simple Confirm */}
        <ConfirmModal
          show={showSimpleConfirm}
          title="Confirm Delete"
          message="Are you sure you want to delete this subcategory?"
          onConfirm={handleConfirm}
          onCancel={() => {
            setShowSimpleConfirm(false);
            setSubcategoryToDelete(null);
          }}
        />
      </section>
    </div>
  );
};

export default UpdateCategoryForm;
